import Head from "next/head";

import { useSelectRole } from "hooks/pages/use-select-role/use-select-role";
import { SelectRoleCard } from "components/web-checkout/select-role-card/select-role-card";
import { LoginBackground } from "components/web-checkout/login-background/login-background";

const SelectRole = (): JSX.Element => {
  const { routerPath } = useSelectRole();

  return (
    <LoginBackground routerPath={routerPath}>
      <Head>
        <title>CoLearn | Pilih profil</title>
      </Head>

      <SelectRoleCard />
    </LoginBackground>
  );
};

export default SelectRole;

SelectRole.requireAuth = true;
